import { usartChangeMode, usartChangeHardwareFlowControl } from './usart';
import { spiChangeMode, spiChangeHardwareNssSignal, spiChangeBaudRatePrescaler } from './spi';

import { generateCode } from './generator';
import { resetState, changeSignal } from './pin';
import { loadData, loadIpData } from './loader';
import { ENV_WEB } from './constants';

const pinout = {

    namespaced: true,
    mutations: {
        init(state, {env, model, projectPath, toolPath} ) {
            state.enviroment = env;
            state.projectPath = projectPath;
            state.toolPath = toolPath;

            // alert(`env=${env}, model=${model}, projectPath=${projectPath}, toolPath=${toolPath}`)
            
            if (model) {
                state.model = model;
            }

            loadData(state);
        },
        selectIP(state, index) {
            state.ipIndex = index;
            state.pinIndex = -1;

            const ip = state.chip.ips[index];
            loadIpData(state, ip.name);
        },
        selectPin(state, index) {
            state.pinIndex = index;
        },
        changeSignal,
        resetState,

        usartChangeMode,
        spiChangeMode,
    },
    actions: {
        generateCode,
        usartChangeHardwareFlowControl,
        spiChangeHardwareNssSignal,
        spiChangeBaudRatePrescaler,
    },
    state: {
        model: 'M100_144',
        chip: {
            ips: [],
            pins: []
        },

        config: {},

        ipIndex: 0,
        pinIndex: -1,

        enviroment: ENV_WEB,
        projectPath: '',
        toolPath: ''
    }
};


export default pinout;